import { Paper, Stack, Typography } from '@mui/material';
import Grid2 from '@mui/material/Unstable_Grid2';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { Navigator } from '../../../components/Navigator';
import { PageLayout } from '../../../layout';
import { AdminClaimDataOverview } from '../../../modules/claims/claim/ClaimDataOverview';
import { AdminInvoicePageHeader } from '../invoice-detail/modules/AdminInvoicePageHeader';
import { InvoiceContactsInfoBox } from '../invoice-detail/modules/InvoiceContactsInfoBox';
import { InvoiceScheduledActionsBox } from '../invoice-detail/modules/InvoiceScheduledActionsBox';
import { ClaimScenarioInfoBox } from './modules/ClaimScenarioInfoBox';
import { ClaimStatusInfoBoxModule } from './modules/ClaimStatusInfoBox';

const TRANS_NS = 'admin-claims';
export const AdminClaimDetail = () => {
  const { t } = useTranslation(TRANS_NS, { keyPrefix: 'detail' });
  const { invoiceId } = useParams();

  const navLinks = [
    {
      href: '#customer',
      label: t('customer'),
    },
    {
      href: '#claim-overview',
      label: t('claim'),
    },
    {
      href: '#scenario-overview',
      label: t('scenario'),
    },
    {
      href: '#claim-detail-scheduledActions',
      label: t('scheduledActions.all'),
    },
  ];

  return (
    <PageLayout>
      {invoiceId ? <AdminInvoicePageHeader invoiceId={invoiceId} transNs={TRANS_NS} keyPrefix={'detail'} /> : null}

      <Grid2 mt={4} container spacing={2}>
        <Grid2 xs={12} md={10}>
          <Stack spacing={4}>
            {invoiceId ? (
              <InvoiceContactsInfoBox invoiceId={invoiceId} id={'customer'} transNs={TRANS_NS} keyPrefix={'detail'} />
            ) : null}
            {invoiceId ? (
              <Paper id={'claim-overview'} sx={{ p: 4 }}>
                <Typography variant={'h2'} mb={4}>
                  {t('claim')}
                </Typography>
                <AdminClaimDataOverview id={invoiceId} />
              </Paper>
            ) : null}
            {invoiceId ? (
              <Paper id={'scenario-overview'} sx={{ p: 4 }}>
                <Typography variant={'h2'} mb={4}>
                  {t('scenario')}
                </Typography>
                <ClaimScenarioInfoBox claimId={invoiceId} />
              </Paper>
            ) : null}
            {invoiceId ? (
              <InvoiceScheduledActionsBox
                transNs={TRANS_NS}
                keyPrefix={'detail'}
                invoiceId={invoiceId}
                id={'claim-detail-scheduledActions'}
              />
            ) : null}
          </Stack>
        </Grid2>
        <Grid2 xs={12} md={2}>
          <Stack gap={4} sx={{ position: 'sticky', top: 20, minWidth: 200 }}>
            {invoiceId ? <ClaimStatusInfoBoxModule claimId={invoiceId} id={'invoiceStatus'} /> : null}
            <Navigator navLinks={navLinks} />
          </Stack>
        </Grid2>
      </Grid2>
    </PageLayout>
  );
};
